export default "/images/203c2c76b1c24cbb2264b92bcf0efe17.avif";